import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TextArea, Popup } from '_atoms';
import { Typography, TYPOGRAPHY_WEIGHT } from '_atoms/Typography';
import history from 'helpers/history';
import { candidateBlacklistAPI, getCandidateInfo, getJobs, getTimeline, setCandidateBlacklist } from 'actions';
import { useAppDispatch } from 'store';
import './style.scss';
import type { CandidateData } from 'store/reducers/candidateReducer';

interface PopupBlacklistProps {
  open: boolean;
  onClose: () => void;
  candidate: CandidateData;
  isSSC?: boolean;
}

export const PopupBlacklist: React.FC<PopupBlacklistProps> = ({ open, onClose, candidate, isSSC }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const [comment, setComment] = useState('');
  const onChangeComment = (e: React.ChangeEvent<HTMLTextAreaElement>) => setComment(e.target.value);

  const onClosePopup = () => {
    setComment('');
    onClose();
  };

  const onBlackList = () => {
    if (isSSC) {
      candidateBlacklistAPI(id, { blacklist_comment: comment }).then(() => {
        history.push(`/candidates/${candidate.uuid}/show`);
        onClose();
      });
    } else {
      setCandidateBlacklist(candidate.uuid, { blacklist_comment: comment }).then(() => {
        dispatch(getCandidateInfo(id));
        dispatch(getJobs(id));
        dispatch(getTimeline(id, undefined, true));
        onClose();
      });
    }
  };

  return (
    <Popup
      open={open}
      title={t('translation:popup_blacklist.title')}
      className="candidate-blacklist"
      cancelButtonProps={{
        children: t('translation:popup_blacklist.cancel'),
        onClick: onClosePopup,
      }}
      okButtonProps={{
        children: t('translation:popup_blacklist.blacklist'),
        disabled: !comment,
        onClick: onBlackList,
      }}
    >
      <Typography.Text className="candidate-blacklist__name-latin" weight={TYPOGRAPHY_WEIGHT.BOLD}>
        {candidate.first_name_latin} {candidate.last_name_latin}
      </Typography.Text>
      <Typography.Caption className="candidate-blacklist__name-local">
        {candidate.first_name_local} {candidate.last_name_local}
      </Typography.Caption>
      <Typography.Text className="candidate-blacklist__warning">
        {t('translation:popup_blacklist.warning_text')}
      </Typography.Text>
      <TextArea
        label={t('translation:popup_blacklist.label_comment')}
        value={comment}
        placeholder={t('translation:popup_blacklist.placeholder_comment')}
        onChange={onChangeComment}
      />
    </Popup>
  );
};
